
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ina",
      function () {
        return require("private-next-pages/ina/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ina"])
      });
    }
  